import { env } from "./env.ts";

export const BaseUrl = env.baseUrl;
export const ZoomSDKKey = env.zoomSDKKey;

export const ChatConnString = BaseUrl + "/chatHub";
export const VerifyUserUrl = BaseUrl + "/api/auth/user/verify";

//Ticket Api's
export const TicketListUrl = BaseUrl + "/api/tickets";
export const KPIUrl = BaseUrl + "/api/tickets/cs/kpi";
export const CustomStatusUrl = BaseUrl + "/api/tickets/custom_status";

//Notification Api's
export const NotificationURL = BaseUrl + "/api/notifications/token";

//Users API
export const CSLUsersURL = BaseUrl + "/api/user/csl";
export const AddUsersToTicketURL = (ticketId: string | number) =>
  BaseUrl + `/api/tickets/${ticketId}/users/batch`;
export const SearchIfuURL = BaseUrl + "/api/Ifu/download";
export const changePasswordURL = BaseUrl + "/api/auth/user/change_password";
export const termsAndConditionsURL = BaseUrl + "/api/user/terms_condition";

//Zoom Call API's
export const SignatureURL = BaseUrl + "/signature";
export const JoinCallURL = BaseUrl + "/join";
export const LeaveCallURL = BaseUrl + "/leave";
